import { type FC, memo, useState } from "react";
import { ActionIconButton, ActionIconButtonType } from "../../../../../common/components/Button/ActionIconButton";
import DeleteCartConfirmationModal from "~/domains/cart/components/DeleteCartConfirmationModal";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
  onClick?: () => void;
  disabled?: boolean;
}

const ClearCartButton: FC<Props> = ({ onClick, disabled }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const cancel = () => setModalOpen(false);
  const confirm = () => {
    setModalOpen(false);
    onClick!();
  };
  const btnDisabled = disabled || !onClick;

  return (
    <>
      <ActionIconButton
        clickableType={ActionIconButtonType.PRIMARY}
        onIconClick={openModal}
        disabled={btnDisabled}
        icon={<DeleteIcon  />}
        id={"cart_clearsection_btn"}
      />
      {modalOpen && (
        <DeleteCartConfirmationModal onCancel={cancel} onOk={confirm} messageKey={"deleteConfirmation.section"} />
      )}
    </>
  );
};

export default memo(ClearCartButton);
